module.exports = __webpack_public_path__ + "static/media/AngelsOfAether_Promo01.d4fd4c7e.jpg";